import React, { useEffect, useState } from 'react';
import PaginatedTable from '../PaginatedTable';
import DateTime from '../DateTime';
import { useFirebaseCRUD } from '../../hooks/useFirebaseCRUD';
import { useError } from '../../hooks';

export default function ({ organizationId }) {
  const { getCollection, loading } = useFirebaseCRUD();
  const setError = useError();

  const [rows, setRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [opts, setOpts] = useState({
    sortBy: 'id',
    sortOrder: 'asc',
    itemsPerPage: 10
  });

  // ✅ Fetch paginated data from Firestore
  useEffect(() => {
    async function fetchData() {
      try {
        const allEvents = await getCollection(
          `organizations/${organizationId}/data-retention-events`
        );

        // ✅ Sorting (same as backend)
        const sortedEvents = [...allEvents].sort((a, b) => {
          const { sortBy, sortOrder } = opts;
          if (sortOrder === 'asc') {
            return a[sortBy] > b[sortBy] ? 1 : -1;
          } else {
            return a[sortBy] < b[sortBy] ? 1 : -1;
          }
        });

        // ✅ Pagination
        const startIndex = (currentPage - 1) * opts.itemsPerPage;
        const paginated = sortedEvents.slice(
          startIndex,
          startIndex + opts.itemsPerPage
        );

        setRows(paginated);
        setTotalCount(sortedEvents.length);
      } catch (err) {
        setError(err);
      }
    }

    fetchData();
  }, [organizationId, currentPage, opts]);

  const columns = [
    {
      name: 'ID',
      sortKey: 'id',
      render: (item) => item.id
    },
    {
      name: 'Timestamp',
      sortKey: 'createdAt',
      render: (item) => <DateTime value={item.createdAt} />
    },
    {
      name: 'Instance Type',
      sortKey: 'instanceType',
      render: (item) => item.instanceType
    },
    {
      name: 'Instance ID',
      sortKey: 'instanceId',
      render: (item) => item.instanceId
    }
  ];

  return (
    <div className='box'>
      <PaginatedTable
        className='is-fullwidth is-hoverable'
        columns={columns}
        rows={rows}
        currentPage={currentPage}
        totalCount={totalCount}
        loading={loading}
        setPage={setCurrentPage}
        opts={opts}
        setOpts={setOpts}
      />
    </div>
  );
}
